export default __webpack_public_path__ + "Dynascore_Logo_White_Wordmark.svg";